import { ZooplaLogo } from '@blueprint/logo';
import { Box } from '@zoopla-eng/zds-components/box';
import { Dialog } from '@zoopla-eng/zds-components/dialog';
import { styled } from '@zoopla-eng/zds-components/themes';
import { shouldShowRedirectBanner } from '../../utils/shouldShowRedirectBanner';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { NewHomesBody } from '../NewHomesBody';
import SmartNewHomesLogo from './assets/smart-new-homes-logo.png';
import { trackClose, trackOpen } from './NewHomesRedirectBanner.tracking';

const Divider = styled('div', {
    bg: '$graphicDividerDefault',
    width: '1px',
    height: '30px'
});

export const NewHomesRedirectBanner = () => {
    const { query } = useRouter();

    const showRedirectBanner = shouldShowRedirectBanner(query);

    const onOpenChangeHandler = (open: boolean) => {
        if (!open) {
            trackClose();

            const url = new URL(window.location.href);

            url.searchParams.delete('utm_source');
            url.searchParams.delete('utm_medium');

            window.history.pushState({}, '', url);
        }
    };

    useEffect(() => {
        trackOpen();
    }, []);

    return (
        <Dialog
            isOpen={showRedirectBanner}
            variant="default"
            label="A modal with text in it"
            title="SmartNewHomes is now part of Zoopla"
            titleSize="small"
            onOpenChange={onOpenChangeHandler}
        >
            <Box
                display="flex"
                alignItems={'center'}
                columnGap={'$S400'}
                pb="$S200"
            >
                <ZooplaLogo color="purple" width="110px" />
                <Divider />
                <img
                    src={SmartNewHomesLogo}
                    alt="Smart New Homes logo"
                    width="75px"
                    height="30px"
                />
            </Box>
            <NewHomesBody>
                You'll find even more new homes and developments here. Your
                SmartNewHomes account has not carried over, but you can use the
                same email address to register with Zoopla.
            </NewHomesBody>
        </Dialog>
    );
};
